export function getCardMarker () {

    let cardMarker = document.createElement('img')
    cardMarker.src = require('../../resources/card-marker-2.svg')

    return cardMarker
}

export function get360Marker () {

    let card360Marker = document.createElement('img')
    card360Marker.src = require('../../resources/icon360.svg')

    return card360Marker
}

export function getDroneMarker (){
    var droneMarker = document.createElement('div')
    droneMarker.style.backgroundImage = `url(${require('../../resources/drone-stageonvr.svg')})`
    droneMarker.style.backgroundSize = '100%'
    droneMarker.style.backgroundRepeat = 'no-repeat'
    droneMarker.style.width = '50px'
    droneMarker.style.height = '60px'
    droneMarker.style.cursor = 'pointer'
    return droneMarker
}